import axios from "axios";
import { getAuthToken, clearStorage } from "../helpers";

const getBaseUrl = () => {
  return (
    process.env.REACT_APP_BASEURL ||
    "http://localhost:8080/api/v1/"
  );
};

const options = {
  baseURL: getBaseUrl(),
  headers: {
    Accept: "application/json,text/plain,*/*",
    "Content-Type": "application/json",
  },
};

export const request = axios.create(options);

request.interceptors.request.use(
  (config) => {
    // const token = getAuthToken();
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    try {
      const errorData = error?.response?.data;
      if (
        errorData?.message === "Unauthenticated." ||
        error.response.status === 401
      ) {
        // localStorage.removeItem('authToken');
        clearStorage();
      }
      return Promise.reject(error);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);
